import React from 'react';

export const LocalLoader: React.FC = () => {
    return <div>Chargement en cours...</div>;
};
